import styled from '@emotion/styled';
import { css } from '@emotion/react';

const Path = styled.path`
  stroke-linecap: round;
  stroke-dasharray: 180;
  stroke-dashoffset: 180;
`;

const Checkmark = styled.span`
  --checkbox-dimension: 1.25rem;
  display: block;
  align-self: flex-start;
  border: 0.125rem solid var(--colors-silver-chalice);
  transition: border-color 0.2s ease;
  height: var(--checkbox-dimension);
  width: var(--checkbox-dimension);
  margin-inline-end: 0.5rem;
  flex: 0 0 auto;
`;

const Label = styled.label`
  position: relative;
  display: inline-flex;
  align-items: center;
  text-align: initial;
  cursor: pointer;
  color: var(--colors-trout);
  user-select: none;
  transition: color 0.2s ease;

  ${({ isChecked }) =>
    isChecked &&
    css`
      color: var(--colors-black);

      ${Path} {
        transition: stroke-dashoffset 0.3s cubic-bezier(0.5, 0, 0.25, 1);
        stroke: var(--colors-scooter);
        stroke-dashoffset: 0;
      }

      ${Checkmark} {
        border-color: var(--colors-scooter);
      }
    `}

  @media (hover: hover) {
    &:hover {
      color: var(--colors-black);

      ${({ isChecked }) =>
        !isChecked &&
        css`
          ${Checkmark} {
            border-color: var(--colors-silver-chalice);
          }

          ${Path} {
            stroke: var(--colors-silver-chalice);
          }
        `}
    }
  }
`;

const Checkbox = styled.div`
  display: flex;
`;

const Input = styled.input`
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  visibility: hidden;
  cursor: pointer;
`;

const Svg = styled.svg`
  display: block;
  fill: none;
`;

const Styled = {
  Checkbox,
  Label,
  Input,
  Checkmark,
  Svg,
  Path,
};

export default Styled;
